// KB 상품 ID
// 비컨피던트 샴푸 - 11001728
// 노모어오일 샴푸 - 11002976
// 기브미워터 샴푸 - 11002978
// 린언미 샴푸 - 11002979
// 커션슬리퍼리 트리트먼트 - 11002982
// 너리셔집 앰플 - 11002994
// 모이스쳐집 에센스 - 11002997
// 위드비컨 두피 스캐너 - 11003000

const userAgent = {
  Android: () => (navigator.userAgent.match(/Android/i) ? true : false),
  Ios: () => (navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false), //“/iPhone/i” will match with iphone, IPHONE or IpHOne
};

/**   KB앱내 (KB_USER)  */
export const goToKbCartForKb = (products) => {
  console.log(
    `goToKbCart() --- KB NATIVE REQUEST---  웹을 감싸고 있는 부모가 KB앱 일 경우`,
  );
  console.log('products !!', products);
  // {  (((EX)))
  //   “prd_code” : [“11001728”, “11002976", “11002978”]
  // }
  if (userAgent.Android() || userAgent.Ios()) {
    // 입력 된 링크를 전달하는 Bridge 함수
    userAgent.Android()
      ? window.Android.callFinish(JSON.stringify(products))
      : window.webkit.messageHandlers.callFinish.postMessage(products);
  }
};
export const exitKbWebViewForKb = () => {
  console.log('EXIT KB WEB VIEW 웹을 감싸고 있는 부모가 KB앱 일 경우');
  const KB_PARAM = {
    prd_code: [''],
  };
  console.log('KB_PARAM', KB_PARAM);
  if (userAgent.Android() || userAgent.Ios()) {
    // 입력 된 링크를 전달하는 Bridge 함수
    userAgent.Android()
      ? window.Android.callFinish(JSON.stringify(KB_PARAM))
      : window.webkit.messageHandlers.callFinish.postMessage(KB_PARAM);
  }
};
